module.exports = __webpack_public_path__ + "img/FI25417689.bb8be502.png";